const FONT_FAMILY = 'Roboto';

export const typography = {
  fontFamily: FONT_FAMILY,
  fontWeight: {
    bold: 700,
    default: 400,
    light: 300,
  },
  fontSize: {
    large: 1.25,
    medium: 1.125,
    regular: 0.84375,
    small: 0.667,
  },
};